export const cdnImageUrl = "https://cdn.vole.io";
export const iosApp = "https://itunes.apple.com/tr/app/vole/id1186752997";
export const androidApp =
  "https://play.google.com/store/apps/details?id=vole.io.vole";
